const RutFormatter = rut => {
  if (!rut) return ''
  let formattedRut = ''
  // eliminamos todos los caracteres que no sean un numero del 0 al 9 o una K mayuscula
  const cleanRut = rut.replace(/[^0-9kK]/g, '')
  if (cleanRut.length <= 1) {
    return cleanRut;
  }
  // Obtenemos el numero sin dv y añadimos un punto cada 3 digitos desde izquierda a derecha
  const num = cleanRut.substr(0, cleanRut.length - 1)
  const numFormatted = num.replace(/\B(?=(\d{3}){1,2}(?!\d))/g, '.')
  const dv = cleanRut.substr(cleanRut.length - 1, 1)
  formattedRut = `${numFormatted}-${dv}`
  return formattedRut.toUpperCase();
}

export default RutFormatter